import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getLocationTypes } from '../api'
import { useQuery } from 'react-query'

export const useGetLocationTypesOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        const result = await dispatch(getLocationTypes())
        if (mounted) {
          if (getLocationTypes.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) setStatus('fail')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}

export const useGetLocationTypesCached = () => {
  const dispatch = useAppDispatch()
  const { data, ...rest } = useQuery('locationTypes', async () => {
    await dispatch(getLocationTypes())
  })
  return rest
}
